import { createSelector } from "reselect";

export function createMetaRootSelector(resourceSelector) {
  return createSelector(
    resourceSelector,
    resource => resource.meta
  );
}
